import type { Conversation, ConversationPatch } from "@/types/chat";

/** SSE patches are plain `JSON.parse`d, so their date fields arrive as ISO
 *  strings while the REST paths (via `edenData`) deliver real `Date`s.
 *  Normalise on the way into state so `Conversation` stays honest. */
export function toDateOrNull(value: Date | string | null | undefined): Date | null {
  if (value == null) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Merge a sidebar patch into a loaded conversation. A patch that omits an
 * optional field (older publishers do) keeps what is already known instead of
 * wiping it, and the CRM display name never travels in a patch.
 */
export function mergeConversationPatch(
  existing: Conversation,
  patch: ConversationPatch,
  unreadCount: number = patch.unreadCount,
): Conversation {
  return {
    ...existing,
    ...patch,
    customerDisplayName: existing.customerDisplayName,
    lastCustomerMessageAt:
      patch.lastCustomerMessageAt !== undefined
        ? toDateOrNull(patch.lastCustomerMessageAt)
        : existing.lastCustomerMessageAt,
    unreadCount,
    botState: patch.botState ?? existing.botState,
    botPausedReason: patch.botPausedReason !== undefined ? patch.botPausedReason : existing.botPausedReason,
    needsAttention: patch.needsAttention !== undefined ? patch.needsAttention : existing.needsAttention,
  };
}
